import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { motion } from '../../../theme/motion';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';

import { Table } from './Table';

export const order = {
  DESC: 'desc',
  ASC: 'asc',
};

export function DeviceColumnHead(props) {
  return (
    <sc.Head
      onClick={props.onClick}
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
      sortable={props.sortable}
      isOrdered={props.sort === props.orderBy}
    >
      <sc.Spacer>
        <sc.Text>{props.children}</sc.Text>
        {props.sortable && (
          <sc.Sortable>
            <sc.SortIcon
              size={theme.icon.size_small}
              color={props.sort === props.orderBy ? theme.color.highlight : theme.color.icon_light}
              source={
                props.sort !== props.orderBy
                  ? glyph.core.triangleSmallUpDown
                  : props.orderDirection === order.DESC
                    ? glyph.core.triangleUp
                    : glyph.core.triangleDown
              }
            />
          </sc.Sortable>
        )}
      </sc.Spacer>
    </sc.Head>
  );
}

const SortIcon = styled(Glyph)`
  transition: ${motion.transition.micro};
`;

const Head = styled(Table.th)`
  ${(props) =>
    props.isOrdered !== true &&
    css`
      &:hover {
        ${SortIcon} {
          color: ${theme.color.icon_light_hover};
        }
      }
    `};
`;

const Spacer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Text = styled.div``;

const Sortable = styled.div`
  margin-inline-start: ${su(1)};
`;

const sc = { Head, Spacer, SortIcon, Text, Sortable };
